export type Extension = 'chrome' | 'outlook';

export interface IEnvironmentConfig {
    production: boolean;
    extension: Extension;
    API_URL: string;
    localDevData?: { displayName: string; email: string };
}
